import { Typography } from '@mui/material'
import { styled } from '@mui/material/styles'

export type ClusterVariant = 'hide' | 'flex' | 'grid' | 'ovalCircle'

export const ClusterContainer = styled('div', {
  shouldForwardProp: prop => prop !== 'variant'
})<{ variant: ClusterVariant }>(({ variant }) => ({
  ...(variant === 'flex' ? {
    flexDirection: 'column',
    display: 'flex',
    overflow: 'auto'
  } : {}),
  ...(variant === 'hide' ? {
    display: 'none'
  } : {}),
  ...(variant === 'grid' ? {
    display: 'grid',
    alignItems: 'center',
    gridTemplateColumns: '30vw 40vw 30vw'
  } : {}),
  ...(variant === 'ovalCircle' ? {
    margin: 'auto',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'absolute'
  } : {})
}))

export const GaugeItem = styled('div', {
  shouldForwardProp: prop => prop !== 'ovalItem' && prop !== 'gridItem' && prop !== 'gridMiddle'
})<{ ovalItem?: boolean, gridItem?: boolean, gridMiddle?: boolean }>(({ ovalItem, gridItem, gridMiddle }) => ({
  ...(gridItem ? {
    width: '100%',
    margin: '1rem 0'
  } : {}),
  ...(gridMiddle ? {
    gridColumn: 2,
    gridRow: '1/6'
  } : {}),
  ...(ovalItem ? {
    position: 'absolute',
    margin: 'auto'
  } : {})
}))

export const DashLabel = styled(Typography)({
  textTransform: 'uppercase',
  textAlign: 'center',
  color: 'var(--primary-color)',
  marginTop: '0.25vw !important',
  letterSpacing: 1
})
